
import React from "react";

interface UnitSelectorProps {
  currentUnit: "hours" | "days";
  onUnitChange: (unit: "hours" | "days") => void;
}

export function UnitSelector({ currentUnit, onUnitChange }: UnitSelectorProps) {
  return (
    <div className="flex rounded-md overflow-hidden border border-primary/20">
      <button 
        type="button" 
        onClick={() => onUnitChange("hours")} 
        className={`px-3 py-2 text-sm transition-all duration-300 ${currentUnit === "hours" ? "bg-primary text-primary-foreground font-semibold" : "bg-[#F1F1F1] text-gray-600 hover:bg-[#E5E5E5]"}`}
      >
        Hours
      </button>
      <button 
        type="button" 
        onClick={() => onUnitChange("days")} 
        className={`px-3 py-2 text-sm transition-all duration-300 ${currentUnit === "days" ? "bg-primary text-primary-foreground font-semibold" : "bg-[#F1F1F1] text-gray-600 hover:bg-[#E5E5E5]"}`}
      >
        Days
      </button>
    </div>
  );
}
